import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";
// import FixtureReducer from "./reducers/fixtureReducer";
import SearchReducer from "./reducers/searchReducer";
import PagingReducer from "./reducers/pagingReducer";
// import filterReducer from "./reducers/filterReducer";
// import LoadingReducer from "./reducers/loadingReducer";
// import OddsDisplayTypeReducer from "./reducers/oddsDisplayTypeReducer";
import BookmakerReducer from "./reducers/bookmarkerReducer";
// import TeamReducer from "./reducers/teamReducer";
import SearchHistoryReducer from "./reducers/searchHistoryReducer";
import FavoriteReducer from "./reducers/favoriteReducer";
import FixtureRouteReducer from "./reducers/fixtureRouteReducer";
import FixtureFavoriteRouteReducer from "./reducers/fixtureFavoriteRouteReducer";
import ThemeReducer from "./reducers/themeReducer";
import LeagueReducer from './reducers/leagueReducer';
import BookmarkerExtendReducer from './reducers/bookmarkerExtendReducer';
import OddsPeriodReducer from './reducers/oddsPeriodReducer';
import ToggleReducer from "./reducers/toggleReducer";
import MatchReducer from "./reducers/matchReducer";

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: "keobongvip",
  storage,
  keyPrefix: "redux-",
  whitelist: [
    // "i18n",
    // "fixtureReducer",
    // "livesScoresFixtureReducer",
    // "bookmakerReducer",
    // "oddsDisplayTypeReducer",
    // "favoriteReducer",
    // "euroReducer",
    // "fixtureTeamReducer",
    // "teamReducer"
    "themeReducer",
    "favoriteReducer",
    // "fixtureRouteReducer",
    "fixtureFavoriteRouteReducer",
    "fixtureFavoriteRouteReducer",
    // "searchReducer",
    "searchHistoryReducer",
    "pagingReducer",
    "toggleReducer"
  ],
};

const rootReducer: any = combineReducers({
  // // add reducer here
  // liveOddsReducer: LiveOddsReducer,
  // livesScoresFixtureReducer: LiveScoresFixtureReducer,
  // fixtureReducer: FixtureReducer,
  // filterReducer: filterReducer,
  // loadingReducer: LoadingReducer,
  // oddsDisplayTypeReducer: OddsDisplayTypeReducer,
  // bookmakerReducer: BookmakerReducer,
  // teamReducer: TeamReducer,
  // i18n: i18nReducer,
  // euroReducer: EuroReducer,
  // favoriteReducer: FavoriteReducer,
  // fixtureTeamReducer: FixtureTeamReducer
  searchReducer: SearchReducer,
  pagingReducer: PagingReducer,
  themeReducer: ThemeReducer,
  favoriteReducer: FavoriteReducer,
  fixtureRouteReducer: FixtureRouteReducer,
  fixtureFavoriteRouteReducer: FixtureFavoriteRouteReducer,
  searchHistoryReducer: SearchHistoryReducer,
  bookmakerReducer: BookmakerReducer,
  leagueReducer: LeagueReducer,
  bookmarkerExtendReducer: BookmarkerExtendReducer,
  oddsPeriodReducer: OddsPeriodReducer,
  toggleReducer: ToggleReducer,
  matchReducer: MatchReducer
});

export { rootPersistConfig, rootReducer };
